export default "__VITE_ASSET__QNO9FV46__"